// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/css-loader/index.js??ref--3-1!../node_modules/vue-loader/dist/stylePostLoader.js!../node_modules/postcss-loader/lib/index.js??ref--3-2!../node_modules/vue-loader/dist/index.js??ref--1!./App.vue?vue&type=style&index=0&id=36fb3f2c&lang=css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("df32fce8", content, true, {});